/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { Suspense } from "react";
import IdleTimerContainer from "../components/IdleTimerContainer.jsx";
import ScrollToTop from "../components/ScrollToTop.jsx";
import KioskSessionManager from "../domains/flexOffice/kiosk/KioskSessionManager.jsx";
import { CompanyProvider } from "../context/CompanyContext.jsx";
import { DomainError, DomainLoading } from "../domain/Domain";
import { ThemeRouteSync } from "../domains/common/routes/ThemeRouteSync.jsx";
import { TEMPLATE_AUTH_DOMAIN_TYPES } from "../domains/config/domainAccessGroups";
import { getDomainApp } from "../domains/DomainAppRegistry.jsx";

function MainRoutes({ siteContext }) {
  const domainType = siteContext?.domainType;
  const DomainApp = getDomainApp(domainType);
  const usesTemplateAuth = TEMPLATE_AUTH_DOMAIN_TYPES.includes(domainType);

  if (!siteContext || !domainType || !DomainApp) {
    return <DomainError />;
  }

  return (
    <Suspense fallback={<DomainLoading />}>
      <CompanyProvider value={siteContext.company || {}}>
        <ThemeRouteSync domainType={domainType} />
        <ScrollToTop />
        <IdleTimerContainer />
        <KioskSessionManager />
        <div
          data-resolved-domain={domainType}
          data-site-key={siteContext.siteKey}
        >
          <DomainApp siteContext={siteContext} usesTemplateAuth={usesTemplateAuth} />
        </div>
      </CompanyProvider>
    </Suspense>
  );
}

export default MainRoutes;
